import React, { useContext, useEffect, useReducer } from 'react'
import axios from 'axios'
import reducer from '../reducers/website_reducer'
import { publications_url as url } from '../utils/constants'
import {
    SIDEBAR_OPEN,
    SIDEBAR_CLOSE,
    GET_PUBLICATIONS_BEGIN,
    GET_PUBLICATIONS_SUCCESS,
    GET_PUBLICATIONS_ERROR,
  } from '../actions'

const initialState = {
    isSidebarOpen: false,
    publications_loading: false,
    publications_error: false,
    publications:[],
  }


const WebsiteContext = React.createContext();

export const WebsiteProvider = ({children}) => {

    const [state, dispatch] = useReducer(reducer, initialState);

     const openSidebar = () => {
        dispatch({type: SIDEBAR_OPEN})
      }
    
      const closeSidebar = () => {
        dispatch({type: SIDEBAR_CLOSE})
      }

      const fetchPublications = async (url) => {
        dispatch({type: GET_PUBLICATIONS_BEGIN });
        try{
          const response = await axios.get(url);
          const publications = response.data;
          //console.log(publications);
    
          dispatch({type: GET_PUBLICATIONS_SUCCESS, payload: publications});
    
        } catch(error){
          dispatch({type: GET_PUBLICATIONS_ERROR})
        }

      }
      useEffect(() => {
        fetchPublications(url);
      }, [])

    return (
        <WebsiteContext.Provider value={{ ...state, openSidebar, closeSidebar } }>
          {children}
        </WebsiteContext.Provider>
      )
}

// make sure use
export const useWebsiteContext = () => {
    return useContext(WebsiteContext)
  }
